// import React, { useState, useMemo } from "react";
// import { toast } from "react-toastify";
// import { Link, useNavigate } from "react-router-dom";
// import useApiRequest from "../../../../Hooks/apiReq";
// import TitleSection from "../../../../Shared/TitleSection/TitleSection";
// import Loader from "../../../../CommonComponets/Loader";
// import DateFilterBar from "../../../../CommonComponets/DateFilterBar/DateFilterBar";
// import Pagination from "../../Componets/Pagination/Pagination"; // Import Pagination
// import { convertToINRFormat } from "../../../../Utils/INRConvert";
// import moment from "moment";
// import { AssoPayoutListData } from "../../constant/PayoutData";
// import { FaTimesCircle, FaMoneyCheckAlt, FaCalendarAlt } from "react-icons/fa";
// import styles from "./MyPayoutsOrg.module.css"; // Import Module CSS

// const MyPayoutsOrg = () => {
//   const { loading, sendApiRequest } = useApiRequest();
//   const navigate = useNavigate();

//   // Data State
//   const [myAllPayouts, setPayouts] = useState(AssoPayoutListData);
//   const [filterRange, setFilterRange] = useState(null);

//   // Pagination State
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(15);

//   // --- Pagination Logic (Memoized) ---
//   const currentTableData = useMemo(() => {
//     const firstPageIndex = (currentPage - 1) * itemsPerPage;
//     const lastPageIndex = firstPageIndex + itemsPerPage;
//     return myAllPayouts.slice(firstPageIndex, lastPageIndex);
//   }, [currentPage, itemsPerPage, myAllPayouts]);

//   // Handlers for Pagination
//   const handlePageChange = (page) => setCurrentPage(page);
//   const handlePageSizeChange = (size) => {
//     setItemsPerPage(size);
//     setCurrentPage(1);
//   };

//   // --- Filter Logic ---
//   const GetAssociatePayout = (from, to) => {
//     if (!from || !to) {
//       toast.warn("Please select a valid date range.");
//       return;
//     }
//     const formattedFromDate = moment(from).format("DD-MM-YYYY");
//     const formattedToDate = moment(to).format("DD-MM-YYYY");

//     if (
//       filterRange &&
//       filterRange.from === formattedFromDate &&
//       filterRange.to === formattedToDate
//     )
//       return;

//     const data = {
//       FromDate: formattedFromDate,
//       ToDate: formattedToDate,
//       DeviceType: "Web",
//       TransactionType: "",
//     };

//     sendApiRequest(
//       "POST",
//       "/GetAssociatePayout",
//       { ...data },
//       {
//         onSuccess: (res) => {
//           setPayouts(res?.Response?.AssoPayoutListData || []);
//           setFilterRange({ from: formattedFromDate, to: formattedToDate });
//           setCurrentPage(1); // Reset to first page on filter
//         },
//         onStatus3: () => navigate("/login"),
//       },
//     );
//   };

//   const clearFilter = () => {
//     setFilterRange(null);
//     setPayouts(AssoPayoutListData); // Reset data
//     setCurrentPage(1);
//     toast.info("Filter cleared");
//   };

//   // --- Helpers ---
//   const convertInMonthsFormat = (input) => {
//     if (!input) return "-";
//     const date = moment(input, "DD-MM-YYYY");
//     return date.isValid() ? date.format("DD MMMM YYYY") : input;
//   };

//   const calculateTotal = (arr, key) => {
//     return arr?.reduce((acc, item) => acc + Number(item?.[key] || 0), 0);
//   };

//   return (
//     <div>
//       {/* 1. Header Section */}
//       <div className={styles.headerWrapper}>
//         <div className={styles.headerTitleGroup}>
//           <div>
//             <TitleSection text="My Payouts" />
//             <div className={styles.recordCount}>
//               Total Records: {myAllPayouts?.length || 0}
//             </div>
//           </div>
//         </div>

//         <DateFilterBar onGo={GetAssociatePayout} />
//       </div>

//       {/* 2. Active Filter Chip */}
//       {filterRange && (
//         <div className={styles.activeFilterBar}>
//           <div className={styles.filterChip}>
//             <FaCalendarAlt />
//             <span>
//               {filterRange.from} to {filterRange.to}
//             </span>
//             <button
//               onClick={clearFilter}
//               className={styles.clearFilterBtn}
//               title="Clear Filter"
//             >
//               <FaTimesCircle size={16} />
//             </button>
//           </div>
//         </div>
//       )}

//       {/* 3. Table Card */}
//       <div className={styles.tableCard}>
//         <div className={styles.tableResponsive}>
//           <table className={styles.customTable}>
//             <thead>
//               <tr>
//                 <th style={{ width: "5%" }}>#</th>
//                 <th style={{ width: "20%" }}>Payout Month</th>
//                 <th className="text-end">Self Business</th>
//                 <th className="text-end">Team Business</th>
//                 <th className="text-end">Self Comm.</th>
//                 <th className="text-end">Team Comm.</th>
//                 <th className="text-end" style={{ width: "15%" }}>
//                   Total Payout
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentTableData.length > 0 ? (
//                 currentTableData.map((item, index) => {
//                   // Calculate absolute index for pagination
//                   const absoluteIndex =
//                     (currentPage - 1) * itemsPerPage + index + 1;
//                   return (
//                     <tr key={index} className={styles.tableRow}>
//                       <td className="ps-4 fw-bold text-muted">
//                         {absoluteIndex}
//                       </td>
//                       <td>
//                         <Link
//                           to={`/my-payouts/my-payout-detail`}
//                           state={{
//                             payoutNo: item.PayoutNo,
//                             backLink: "/my_payouts",
//                           }}
//                           className={styles.payoutLink}
//                         >
//                           {convertInMonthsFormat(item?.AddedOn)}
//                         </Link>
//                         <span className={styles.payoutId}>
//                           ID: {item.PayoutNo}
//                         </span>
//                       </td>

//                       <td className="text-end">
//                         <div className="fw-bold">
//                           {convertToINRFormat(item?.SelfBusiness)}
//                         </div>
//                         <div className={styles.pvLabel}>
//                           PV: {parseInt(item?.SelfBusinessPV)}
//                         </div>
//                       </td>

//                       <td className="text-end">
//                         <div className="fw-bold">
//                           {convertToINRFormat(item?.TeamBusiness)}
//                         </div>
//                         <div className={styles.pvLabel}>
//                           PV: {parseInt(item?.TeamBusinessPV)}
//                         </div>
//                       </td>

//                       <td className="text-end text-secondary fw-semibold">
//                         {convertToINRFormat(item?.SelfIncome)}
//                       </td>
//                       <td className="text-end text-secondary fw-semibold">
//                         {convertToINRFormat(item?.TeamIncome)}
//                       </td>

//                       <td className="text-end pe-4">
//                         <span className={styles.totalBadge}>
//                           {convertToINRFormat(item?.TotalIncome)}
//                         </span>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan={7} className="text-center py-5">
//                     <div className="d-flex flex-column align-items-center opacity-50">
//                       <FaMoneyCheckAlt size={40} className="mb-3 text-muted" />
//                       <h6 className="text-muted fw-normal">
//                         No payout records found.
//                       </h6>
//                     </div>
//                   </td>
//                 </tr>
//               )}

//               {/* Grand Total Row (Always calculated on FULL dataset, not just current page) */}
//               {myAllPayouts.length > 0 && (
//                 <tr className={styles.totalRow}>
//                   <td colSpan={2} className="ps-4">
//                     TOTAL
//                   </td>
//                   <td className="text-end">-</td>
//                   <td className="text-end">-</td>
//                   <td className="text-end">
//                     {convertToINRFormat(
//                       calculateTotal(myAllPayouts, "SelfIncome"),
//                     )}
//                   </td>
//                   <td className="text-end">
//                     {convertToINRFormat(
//                       calculateTotal(myAllPayouts, "TeamIncome"),
//                     )}
//                   </td>
//                   <td className="text-end pe-4 text-primary">
//                     {convertToINRFormat(
//                       calculateTotal(myAllPayouts, "TotalIncome"),
//                     )}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* 4. Pagination Footer */}
//         {myAllPayouts.length > 0 && (
//           <div className={styles.paginationWrapper}>
//             <Pagination
//               currentPage={currentPage}
//               totalItems={myAllPayouts.length}
//               itemsPerPage={itemsPerPage}
//               onPageChange={handlePageChange}
//               onPageSizeChange={handlePageSizeChange}
//               pageSizeOptions={[15, 20, 50, 100]}
//             />
//           </div>
//         )}
//       </div>

//       {loading && <Loader />}
//     </div>
//   );
// };

// export default MyPayoutsOrg;

import React, { useState, useMemo } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import useApiRequest from "../../../../Hooks/apiReq";
import TitleSection from "../../../../Shared/TitleSection/TitleSection";
import Loader from "../../../../CommonComponets/Loader";
import DateFilterBar from "../../../../CommonComponets/DateFilterBar/DateFilterBar";
import Pagination from "../../Componets/Pagination/Pagination";
import { convertToINRFormat } from "../../../../Utils/INRConvert";
import moment from "moment";
import { AssoPayoutListData } from "../../constant/PayoutData";
import { FaTimesCircle, FaMoneyCheckAlt, FaCalendarAlt } from "react-icons/fa";
import styles from "./MyPayoutsOrg.module.css";

// --- 1. Skeleton Component ---
const TableSkeleton = () => {
  return (
    <>
      {Array.from({ length: 8 }).map((_, index) => (
        <tr key={index} className={styles.skeletonRow}>
          <td>
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText}`}
              style={{ width: "20px" }}
            ></div>
          </td>
          <td>
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText}`}
              style={{ width: "80%", height: "16px", marginBottom: "6px" }}
            ></div>
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText}`}
              style={{ width: "50%", height: "10px" }}
            ></div>
          </td>
          <td className="text-end">
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText} ms-auto`}
              style={{ width: "70px" }}
            ></div>
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText} ms-auto`}
              style={{ width: "40px", height: "10px", marginTop: "6px" }}
            ></div>
          </td>
          <td className="text-end">
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText} ms-auto`}
              style={{ width: "70px" }}
            ></div>
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText} ms-auto`}
              style={{ width: "40px", height: "10px", marginTop: "6px" }}
            ></div>
          </td>
          <td className="text-end">
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText} ms-auto`}
              style={{ width: "60px" }}
            ></div>
          </td>
          <td className="text-end">
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText} ms-auto`}
              style={{ width: "60px" }}
            ></div>
          </td>
          <td className="text-end pe-4">
            <div
              className={`${styles.skeletonPulse} ${styles.skeletonText} ms-auto`}
              style={{ width: "90px", height: "28px", borderRadius: "14px" }}
            ></div>
          </td>
        </tr>
      ))}
    </>
  );
};

// --- 2. Main Component ---
const MyPayoutsOrg = () => {
  const { loading, sendApiRequest } = useApiRequest();
  const navigate = useNavigate();

  // Data State
  const [myAllPayouts, setPayouts] = useState(AssoPayoutListData);
  const [filterRange, setFilterRange] = useState(null);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  // --- Pagination Logic (Memoized) ---
  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * itemsPerPage;
    const lastPageIndex = firstPageIndex + itemsPerPage;
    return myAllPayouts.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, itemsPerPage, myAllPayouts]);

  // Handlers
  const handlePageChange = (page) => setCurrentPage(page);
  const handlePageSizeChange = (size) => {
    setItemsPerPage(size);
    setCurrentPage(1);
  };

  // --- Filter Logic ---
  const GetAssociatePayout = (from, to) => {
    if (!from || !to) {
      toast.warn("Please select a valid date range.");
      return;
    }
    const formattedFromDate = moment(from).format("DD-MM-YYYY");
    const formattedToDate = moment(to).format("DD-MM-YYYY");

    if (
      filterRange &&
      filterRange.from === formattedFromDate &&
      filterRange.to === formattedToDate
    )
      return;

    const data = {
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
      DeviceType: "Web",
      TransactionType: "",
    };

    sendApiRequest(
      "POST",
      "/GetAssociatePayout",
      { ...data },
      {
        onSuccess: (res) => {
          setPayouts(res?.Response?.AssoPayoutListData || []);
          setFilterRange({ from: formattedFromDate, to: formattedToDate });
          setCurrentPage(1);
        },
        onStatus3: () => navigate("/login"),
      },
    );
  };

  const clearFilter = () => {
    setFilterRange(null);
    setPayouts(AssoPayoutListData);
    setCurrentPage(1);
    toast.info("Filter cleared");
  };

  // --- Helpers ---
  const convertInMonthsFormat = (input) => {
    if (!input) return "-";
    const date = moment(input, "DD-MM-YYYY");
    return date.isValid() ? date.format("DD MMMM YYYY") : input;
  };

  const calculateTotal = (arr, key) => {
    return arr?.reduce((acc, item) => acc + Number(item?.[key] || 0), 0);
  };

  return (
    <div>
      {/* 1. Header Section */}
      <div className={styles.headerWrapper}>
        <div className={styles.headerTitleGroup}>
          <div>
            <TitleSection text="My Payouts" />
            <div className={styles.recordCount}>
              Total Records: {myAllPayouts?.length || 0}
            </div>
          </div>
        </div>

        <DateFilterBar onGo={GetAssociatePayout} />
      </div>

      {/* 2. Active Filter Chip */}
      {filterRange && (
        <div className={styles.activeFilterBar}>
          <div className={styles.filterChip}>
            <FaCalendarAlt />
            <span>
              {filterRange.from} to {filterRange.to}
            </span>
            <button
              onClick={clearFilter}
              className={styles.clearFilterBtn}
              title="Clear Filter"
            >
              <FaTimesCircle size={16} />
            </button>
          </div>
        </div>
      )}

      {/* 3. Table Card */}
      <div className={styles.tableCard}>
        <div className={styles.tableResponsive}>
          <table className={styles.customTable}>
            <thead>
              <tr>
                <th style={{ width: "5%" }}>#</th>
                <th style={{ width: "20%" }}>Payout Month</th>
                <th className="text-end">Self Business</th>
                <th className="text-end">Team Business</th>
                <th className="text-end">Self Comm.</th>
                <th className="text-end">Team Comm.</th>
                <th className="text-end" style={{ width: "15%" }}>
                  Total Payout
                </th>
              </tr>
            </thead>
            <tbody>
              {/* --- CONDITIONALLY RENDER SKELETON OR DATA --- */}
              {loading ? (
                <TableSkeleton />
              ) : currentTableData.length > 0 ? (
                currentTableData.map((item, index) => {
                  const absoluteIndex =
                    (currentPage - 1) * itemsPerPage + index + 1;
                  return (
                    <tr key={index} className={styles.tableRow}>
                      <td className="ps-4 fw-bold text-muted">
                        {absoluteIndex}
                      </td>
                      <td>
                        <Link
                          to={`/my-payouts/my-payout-detail`}
                          state={{
                            payoutNo: item.PayoutNo,
                            backLink: "/my_payouts",
                          }}
                          className={styles.payoutLink}
                        >
                          {convertInMonthsFormat(item?.AddedOn)}
                          <span className={styles.payoutId}>
                            ID: {item.PayoutNo}
                          </span>
                        </Link>
                      </td>

                      <td className="text-end">
                        <div className="fw-bold">
                          {convertToINRFormat(item?.SelfBusiness)}
                        </div>
                        <div className={styles.pvLabel}>
                          PV: {parseInt(item?.SelfBusinessPV)}
                        </div>
                      </td>

                      <td className="text-end">
                        <div className="fw-bold">
                          {convertToINRFormat(item?.TeamBusiness)}
                        </div>
                        <div className={styles.pvLabel}>
                          PV: {parseInt(item?.TeamBusinessPV)}
                        </div>
                      </td>

                      <td className="text-end text-secondary fw-semibold">
                        {convertToINRFormat(item?.SelfIncome)}
                      </td>
                      <td className="text-end text-secondary fw-semibold">
                        {convertToINRFormat(item?.TeamIncome)}
                      </td>

                      <td className="text-end pe-4">
                        <span className={styles.totalBadge}>
                          {convertToINRFormat(item?.TotalIncome)}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7} className="text-center py-5">
                    <div className="d-flex flex-column align-items-center opacity-50">
                      <FaMoneyCheckAlt size={40} className="mb-3 text-muted" />
                      <h6 className="text-muted fw-normal">
                        No payout records found.
                      </h6>
                    </div>
                  </td>
                </tr>
              )}

              {/* Grand Total Row (Hidden when loading) */}
              {!loading && myAllPayouts.length > 0 && (
                <tr className={styles.totalRow}>
                  <td colSpan={2} className="ps-4">
                    TOTAL
                  </td>
                  <td className="text-end">-</td>
                  <td className="text-end">-</td>
                  <td className="text-end">
                    {convertToINRFormat(
                      calculateTotal(myAllPayouts, "SelfIncome"),
                    )}
                  </td>
                  <td className="text-end">
                    {convertToINRFormat(
                      calculateTotal(myAllPayouts, "TeamIncome"),
                    )}
                  </td>
                  <td className="text-end pe-4 text-primary">
                    {convertToINRFormat(
                      calculateTotal(myAllPayouts, "TotalIncome"),
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 4. Pagination Footer (Hidden when loading) */}
        {!loading && myAllPayouts.length > 0 && (
          <div className={styles.paginationWrapper}>
            <Pagination
              currentPage={currentPage}
              totalItems={myAllPayouts.length}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              pageSizeOptions={[15, 20, 50, 100]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyPayoutsOrg;
